import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  InfoCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import {
  Button,
  ConfigProvider,
  DatePicker,
  Drawer,
  Select,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getMainProduct, getProduct, getThread } from "../redux/selectors";
import { getFeedFilter } from "../redux/selectors/feed-filter.selectors";
import { summaryService } from "../api";
import { calcChange } from "../scripts/utils";

type Props = {
  title: any;
};

const Coverage: any = ({ title }: Props) => {
  const [open, setOpen] = useState(false);
  const mainProduct = useSelector(getMainProduct);
  const [data, setData] = useState<any>({
    activity: 0,
    attendance: 0,
    previous: { attendance: 0, viewed: 0, activity: 0 },
    viewed: 0,
  });
  const [network, setNetwork] = useState(1);
  const [loading, setLoading] = useState(true);
  const feedFilter = useSelector(getFeedFilter);
  const thread = useSelector(getThread);
  const product = useSelector(getProduct);
  const start = new Date();
  start.setDate(start.getDate() - 29);

  useEffect(() => {
    setLoading(true);
    if (thread && mainProduct && product) {
      let params = {
        thread_id: +thread.id,
        product_id: window.location.pathname.includes("main")
          ? mainProduct?.id
          : product,
        from: feedFilter.from.slice(0, 10) + " 00:00:00",
        to: feedFilter.to.slice(0, 10) + " 23:59:59",
        network_id: network,
      };

      summaryService
        .loadClientStats(params)
        .then((resp) => {
          setData(resp);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [thread, network, product, feedFilter, product, title, mainProduct]);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleChangeNetwork = (value: number) => {
    setNetwork(value);
  };

  return (
    <div className="white-block-small">
      <div className="flex-space">
        <p className="block-title">
          {title == "viewed"
            ? "Просмотры"
            : title == "activity"
            ? "Активность"
            : "Приблизительный охват"}
          <InfoCircleOutlined className="info" onClick={showDrawer} />
        </p>
        <ConfigProvider
          theme={{
            components: {
              Select: {
                activeBorderColor: "#7856FE",
              },
            },
          }}
        >
          <Select
            value={network}
            onChange={handleChangeNetwork}
            style={{ width: 120 }}
            allowClear={false}
            options={[
              { value: 1, label: "ВКонтакте" },
              { value: 5, label: "Telegram" },
              { value: 10, label: "Одноклассники" },
              { value: 8, label: "Youtube" },
              { value: 11, label: "Дзен" },
              { value: 4, label: "СМИ" },
            ]}
          />
        </ConfigProvider>
      </div>
      {loading || data.errors ? (
        <div className="feed-posts-loader" style={{ height: "300px" }}>
          <LoadingOutlined />
        </div>
      ) : (
        <div className="text-center">
          <Tooltip
            color={"#7856FE"}
            title="Процент роста/спада показателей, по сравнению с предыдущим периодом"
          >
            <p
              className={data[title] <= data?.previous[title] ? "red" : "green"}
            >
              {calcChange(data[title], data?.previous[title])}%
              {data[title] <= data.previous[title] ? (
                <ArrowDownOutlined />
              ) : (
                <ArrowUpOutlined />
              )}
            </p>
          </Tooltip>
          <div
            className={
              data[title] > 100000000
                ? "title-big margin-bottom"
                : "title-large margin-bottom"
            }
          >
            {data[title]?.toLocaleString()}
          </div>
          <Button onClick={showDrawer}>Подробнее</Button>
        </div>
      )}
      <Drawer
        title="Что отображает этот показатель?"
        onClose={onClose}
        open={open}
      >
        <div className="overflow-block">
          <p className="purple-border">
            {title == "viewed"
              ? "Данный показатель отображает суммарное число просмотров всех публикаций с упоминаниями компании в выбранной социальной сети за период."
              : title == "activity"
              ? "Доля активной аудитории, взаимодействующей с публикациями (оставляют реакции: комментарии, лайки, репосты). Формула: сумма пользовательских реакций/суммарный охват * 100%"
              : "Данный показатель транслирует суммарный охват аудитории источников выбранной социальной сети/СМИ, опубликовавших информацию о компании за период. Охваты социальных сетей и СМИ подсчитаны только на основе уникальных источников. Другими словами, при подсчете охват каждого источника использовался только один раз, даже если один источник размещал несколько публикаций."}
          </p>
          <p className="title-small">Как интерпретировать данные</p>
          <ol>
            <li>
              Цветным шрифтом выделен процент роста/спада показателей по
              сравнению с предыдущим периодом.
            </li>
            <li>
              Временные интервалы: Вы можете выбрать различные временные
              интервалы для анализа динамики.
            </li>
            <li>
              Источники данных: Вы можете выбрать различные информационные
              источники для анализа.
            </li>
          </ol>
          <p className="gray-block">
            <p className="gray-title">ПРИМЕЧАНИЕ</p>Данные обновляются в
            реальном времени, что позволяет вам следить за актуальными трендами
            и реакцией аудитории на ваш контент
          </p>
        </div>
      </Drawer>
    </div>
  );
};

export default Coverage;
